export function debouncePromise(fn, 
// sensible default for type-aheads
waitMs = 300) {
    // @ts-expect-error - TS7034 - Variable 'timeout' implicitly has type 'any' in some locations where its type cannot be determined.
    let timeout;
    return (...args) => new Promise((resolve, reject) => {
        // @ts-expect-error - TS7005 - Variable 'timeout' implicitly has an 'any' type.
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
            resolve(fn.apply(this, args));
        }, waitMs);
    });
}
export const debounce = (fn, waitMs = 300) => {
    // @ts-expect-error - TS7034 - Variable 'timeout' implicitly has type 'any' in some locations where its type cannot be determined.
    let timeout;
    return (...args) => {
        // @ts-expect-error - TS7005 - Variable 'timeout' implicitly has an 'any' type.
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => fn(...args), waitMs);
    };
};
